<script lang="ts">
  import CollectionsList from './CollectionsList.svelte'
  import {user} from '../stores/user'
</script>

<CollectionsList url={`/users/${$user?.id}/collections`} displayPlaceholder/>